/** @file The single bone that carries a mesh: the bone of every slot whose skin entries use it. */
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import { meshSlotBones } from './meshSlotBones';

/** Slot bone of attachment `id` (used when setBinding has no `bone`); VALIDATION at `target` when none or several. */
export function meshSlotBone(doc: Doc, id: Id): Id {
  const bones = meshSlotBones(doc, id);
  const [first, second] = [...bones];
  if (first === undefined) return throwError('VALIDATION', undefined, { path: 'target', hint: 'no skin uses this mesh, so it has no slot bone: pass `bone`, or map it with skin.setEntry first' });
  if (second !== undefined) return throwError('VALIDATION', undefined, { path: 'target', hint: `slots on ${bones.size} different bones use this mesh: pass \`bone\` to choose one` });
  return first;
}
